export default __webpack_public_path__ + "static/media/wsproduct.3a99219a.jpg";